import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import _ from "lodash";
import Cart from "./modules/cart";

import DefaultTheme from "../themes/default";
import DefaultCleanTheme from "../themes/default-clean";
import whiteBlackTheme from "../themes/white-black";
import whiteBlackCleanTheme from "../themes/white-black-clean";
import DarkTheme from "../themes/dark";
import DarkCleanTheme from "../themes/dark-clean";

axios.defaults.baseURL =
  "https://qr-menu.outsystemscloud.com/Menu/rest/QRMenuServer/";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currentTheme: localStorage.getItem("theme") || "default",
    themes: {
      default: DefaultTheme,
      "default-clean": DefaultCleanTheme,
      "white-black": whiteBlackTheme,
      "white-black-clean": whiteBlackCleanTheme,
      dark: DarkTheme,
      "dark-clean": DarkCleanTheme,
    },
    languageLocales: {
      de: {
        locale: "de-DE",
        currency: "EUR",
      },
      nl: {
        locale: "nl-NL",
        currency: "EUR",
      },
      fr: {
        locale: "fr-FR",
        currency: "EUR",
      },
      en: {
        locale: "en-US",
        currency: "EUR",
      },
    },
    pageLoading: true,
    loadingItems: false,
    menuHashAvailable: true,
    language: "en",
    currency: "€",
    appUrl: process.env.VUE_APP_URL,

    languagesCount: 0,
    menuId: "",
    menuHash: "",
    orderingSecurityCodeHash: "",
    categoryId: "",
    subCategoryId: "",
    isOrderingEnabled: false,
    processBarCurrentItem: 1,
    currentBottomIcon: "cart",
    isCartViewShown: "false",
    latAddressClient: "",
    longAddressClient: "",

    menu: {},
    selectedMenuCategory: {},
    parentSelectedMenuCategory: {},
    selectedMenuItem: {},
    discountCodeInfo: {},
    menuCategories: [],
    menuCategoriesCategories: [],
    menuSubCategories: [],
    menuItems: [],
    menuSubItems: [],
    orderData: [],
    orderStatus: [],
    selectedModifiers: [],
    isListDisplayed: true,
    isMobileDevice: true,
    isSubSubCategory: false,
    totalDaysVisible: 0,
    calculatedDistanceHomeDelivery: 0,
    address: "",
    city: "",
    zip: "",

    visitorContactDetails: {
      name: "",
      email: "",
      phone: "",
      marketingConsent: false,
    },
  },
  mutations: {
    setCurrentTheme(state, theme) {
      localStorage.setItem("theme", theme);
      state.currentTheme = theme;
    },
    startPageLoading(state) {
      state.pageLoading = true;
    },
    stopPageLoading(state) {
      state.pageLoading = false;
    },
    loadingItems(state, data) {
      state.loadingItems = data;
    },
    menuHashAvailable(state, data) {
      state.menuHashAvailable = data;
    },
    changeLanguage(state, language) {
      state.language = language;
      localStorage.setItem("language", language);
    },
    updateCurrency(state, currency) {
      state.currency = currency;
    },
    updateMenuHash(state, data) {
      state.menuHash = data;
    },
    updateCategoryId(state, data) {
      state.categoryId = data;
    },
    updateSubCategoryId(state, data) {
      state.subCategoryId = data;
    },
    updateMenu(state, data) {
      state.menu = data;
    },
    updateSelectedMenuCategory(state, data) {
      state.selectedMenuCategory = data;
    },
    updateParentSelectedMenuCategory(state, data) {
      state.parentSelectedMenuCategory = data;
    },
    updateMenuCategories(state, data) {
      state.menuCategories = data;
    },
    updateMenuCategoriesCategories(state, data) {
      state.menuCategoriesCategories = data;
    },
    updateMenuSubCategories(state, data) {
      state.menuSubCategories = data;
    },
    updateMenuItems(state, data) {
      state.menuItems = data;
    },
    updateMenuSubItems(state, data) {
      state.menuSubItems = data;
    },
    updateVisitorName(state, name) {
      state.visitorContactDetails.name = name;
    },
    updateVisitorEmail(state, email) {
      state.visitorContactDetails.email = email;
    },
    updateVisitorPhone(state, phone) {
      state.visitorContactDetails.phone = phone;
    },
    updateMarketingConsent(state, status) {
      state.visitorContactDetails.marketingConsent = status;
    },
    enableOrdering(state, status) {
      state.isOrderingEnabled = status;
    },
    updateOrderedData(state, data) {
      state.orderData = data;
    },
    updateOrderStatus(state, status) {
      state.orderStatus = status;
    },
    updateSelectedModifiers(state, data) {
      state.selectedModifiers = data;
    },
    updateOrderingSecurityCodeHash(state, hash) {
      state.orderingSecurityCodeHash = hash;
    },
    updateIsListDisplayed(state, data) {
      state.isListDisplayed = data;
    },
    updateProcessBarCurrentItem(state, value) {
      state.processBarCurrentItem = value;
    },
    updateCurrentBottomIcon(state, value) {
      state.currentBottomIcon = value;
    },
    updateIsCartViewShown(state, value) {
      state.isCartViewShown = value;
    },
    updateIsMobileDevice(state, value) {
      state.isMobileDevice = value;
    },
    updateIsSubSubCategory(state, value) {
      state.isSubSubCategory = value;
    },
    updateTotalDaysVisible(state, value) {
      state.totalDaysVisible = value;
    },
    updateDiscountCodeInfo(state, value) {
      state.discountCodeInfo = value;
    },
    updateLanguagesCount(state, value) {
      state.languagesCount += value;
    },
    updateAddress(state, value) {
      state.address = value;
    },
    updateZip(state, value) {
      state.zip = value;
    },
    updateCountry(state, value) {
      state.country = value;
    },
    updateLatAddressClient(state, value) {
      state.latAddressClient = value;
    },
    updateLongAddressClient(state, value) {
      state.longAddressClient = value;
    },
    updateCalculatedDistanceHomeDelivery(state, value) {
      state.calculatedDistanceHomeDelivery = value;
    },
    updateCity(state, value) {
      state.city = value;
    },
  },
  actions: {
    GET_MENU_ITEMS({ commit, state, getters }) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            "https://q4-api.qr-menu.app/api/GetMenu?MenuHash=" +
              state.menuHash +
              "&sessionId=" +
              getters.sessionId
          )
          .then((response) => {
            commit(
              "Cart/updateExtraChargeAmount",
              response.data.Menu.charge_amount_when_min_spent
            );
            commit("menuHashAvailable", true);
            commit("updateCurrency", response.data.Menu.currency);
            commit("updateMenu", response.data.Menu);
            commit("updateMenuCategories", response.data.MenuCategories);
            commit("stopPageLoading");
            commit("enableOrdering", response.data.Menu.is_ordering_enabled);
            commit(
              "updateOrderingSecurityCodeHash",
              response.data.Menu.ordering_pass_hash
            );
            commit(
              "Cart/updateHomeDeliveryCosts",
              response.data.Menu.delivery_cost
            );
            /** Update available Payment Types when it's available on the API responses. */
            if (response.data.PaymentTypes.length) {
              commit(
                "Cart/updateAvailablePaymentTypes",
                response.data.PaymentTypes
              );
              commit(
                "Cart/updatePaymentTypeId",
                response.data.PaymentTypes[0].Id
              );
            }

            if (response.data.OrderAPI) {
              /** Update Order Status */
              commit("updateOrderStatus", response.data.OrderAPI.orderStatus);

              commit("Cart/updateOrderId", response.data.OrderAPI.orderId);
              /** Update Customer Information */
              _.map(response.data.OrderAPI.Customer, (value, key) => {
                commit("Cart/updateCustomer", { field: key, value: value });
              });
              /** Update TableId */

              /** Update Payment Type ID */
              commit(
                "Cart/updatePaymentTypeId",
                response.data.OrderAPI.PaymentTypeId
              );

              /** Update Cart only if Order Status is `New` or `PendingPayment`. */
              let orderStatus = ["New"];
              if (orderStatus.includes(response.data.OrderAPI.orderStatus)) {
                /** Upate Cart Items */
                response.data.OrderAPI.OrderItems.forEach((element) => {
                  let menuItem = element.MenuItem;
                  menuItem["OrderItemAdditions"] = element.OrderItemAdditions;
                  commit("Cart/addItem", menuItem);
                });
              } else {
                commit("updateOrderedData", response.data.OrderAPI);
              }
            }
            resolve(response);
          })
          .catch((error) => {
            commit("menuHashAvailable", false);
            reject(error);
          });
      });
    },
    GET_MENU_SUB_CATEGORIES({ commit, state }) {
      commit("loadingItems", true);
      return new Promise((resolve, reject) => {
        axios
          .get(
            "https://q4-api.qr-menu.app/api/GetCategoryWithSubCategories?MenuHash=" +
              state.menuHash +
              "&CategoryId=" +
              state.categoryId
          )
          .then((response) => {
            commit(
              "updateParentSelectedMenuCategory",
              response.data.MenuCategory
            );
            commit("updateMenuSubCategories", response.data.SubCategories);
            commit("loadingItems", false);
            commit("stopPageLoading");
            resolve(response);
          })
          .catch((error) => {
            commit("loadingItems", false);
            reject(error);
          });
      });
    },
    GetAllMenuItems({ commit, state }) {
      commit("loadingItems", true);
      return new Promise((resolve, reject) => {
        //TODO get the first MenuCategory for the iPad that for example 'chocolate' is displayed directly
        axios
          .get(`GetAllMenuItems?MenuHash=${state.menuHash}`)
          .then((response) => {
            commit("loadingItems", false);
            commit("updateMenuItems", response.data.MenuItems);
            commit("updateSelectedMenuCategory", response.data.MenuCategory);
            resolve(response);
          })
          .catch((error) => {
            commit("loadingItems", false);
            reject(error);
          });
      });
    },
    GET_CATEGORY({ commit, state }) {
      commit("loadingItems", true);
      return new Promise((resolve, reject) => {
        //TODO get the first MenuCategory for the iPad that for example 'chocolate' is displayed directly
        axios
          .get(
            `https://q4-api.qr-menu.app/api/GetCategory?MenuHash=${state.menuHash}&CategoryId=${state.categoryId}`
          )
          .then((response) => {
            commit("loadingItems", false);
            commit("updateMenuItems", response.data.MenuItems);
            commit("updateSelectedMenuCategory", response.data.MenuCategory);
            resolve(response);
          })
          .catch((error) => {
            commit("loadingItems", false);
            reject(error);
          });
      });
    },
    GET_MENU_SUBITEMS({ commit, state }, menuItemId) {
      commit("loadingItems", true);
      return new Promise((resolve, reject) => {
        axios
          .get(
            `GetMenuItem2?MenuHash=${state.menuHash}&CategoryId=${state.categoryId}&MenuItemId=${menuItemId}`
          )
          .then((response) => {
            commit("updateMenuSubItems", response.data.MenuSubItems);
            commit("loadingItems", false);
            resolve(response);
          })
          .catch((error) => {
            commit("loadingItems", false);
            reject(error);
          });
      });
    },
    GET_DISTANCE_ADDRESSES({ commit }) {
      commit("loadingItems", true);
      return new Promise((resolve, reject) => {
        axios
          .get(
            "https://api.mapbox.com/directions/v5/mapbox/driving/3.82626%2C51.092171%3B3.831266%2C51.089958?alternatives=false&geometries=geojson&steps=false&access_token=pk.eyJ1IjoiamVsbGVnZWVycyIsImEiOiJja20xdWZ0bXAybnFjMnBtd3B3dHU4cm00In0.dc4zJF3PlAUGJCYu4Y6Jvw"
          )
          .then((response) => {
            this.info = response;
            resolve(response);
          })
          .catch((error) => {
            commit("loadingItems", false);
            reject(error);
          });
      });
    },
    GET_LAT_LONG_ADDRESS({ commit, state }, address) {
      commit("loadingItems", true);
      return new Promise((resolve, reject) => {
        axios
          .get(
            "https://api.mapbox.com/geocoding/v5/mapbox.places/" +
              address +
              ".json?access_token=pk.eyJ1IjoiamVsbGVnZWVycyIsImEiOiJja20xdWZ0bXAybnFjMnBtd3B3dHU4cm00In0.dc4zJF3PlAUGJCYu4Y6Jvw"
          )
          .then((response) => {
            axios
              .get(
                "https://api.mapbox.com/directions/v5/mapbox/driving/" +
                  state.menu.delivery_base_long +
                  "%2C" +
                  state.menu.delivery_base_lat +
                  "%3B" +
                  response.data.features[0].center[0] +
                  "%2C" +
                  response.data.features[0].center[1] +
                  "?alternatives=false&geometries=geojson&steps=false&access_token=pk.eyJ1IjoiamVsbGVnZWVycyIsImEiOiJja20xdWZ0bXAybnFjMnBtd3B3dHU4cm00In0.dc4zJF3PlAUGJCYu4Y6Jvw"
              )
              .then((responseDistance) => {
                console.log(responseDistance.data.routes[0].distance / 1000);
                if (responseDistance.data.routes[0].distance) {
                  commit(
                    "updateCalculatedDistanceHomeDelivery",
                    responseDistance.data.routes[0].distance / 1000
                  );
                }
              });
            commit(
              "updateLongAddressClient",
              response.data.features[0].center[0]
            );
            commit(
              "updateLatAddressClient",
              response.data.features[0].center[1]
            );
            this.info = response;
            resolve(response);
          })
          .catch((error) => {
            commit("loadingItems", false);
            reject(error);
          });
      });
    },
    /**
     * Submit Visitor Details to the Server.
     *
     * @param {state} VuexState
     * @param {object} data FormData (Visitor Details - Name & Email)
     */
    SUBMIT_VISITOR_DETAILS({ state }, data) {
      /** Appending MenuID & Current Timestamp before the xhr call. */
      data["MenuId"] = state.menu.Id;
      data["Timestamp"] = new Date();

      return new Promise((resolve, reject) => {
        axios
          .post("PostVisiterLog", data)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
  getters: {
    theme: (state) =>
      Object.hasOwnProperty.call(state.themes, state.currentTheme)
        ? state.themes[state.currentTheme]
        : state.themes["default"],
    pageLoading: (state) => state.pageLoading,
    menuHashAvailable: (state) => state.menuHashAvailable,
    loadingItems: (state) => state.loadingItems,
    language: (state) => state.language,
    currency: (state) => state.currency,
    menuHash: (state) => state.menuHash,
    menu: (state) => state.menu,
    menuSubCategories: (state) => state.menuSubCategories,
    menuCategories: (state) =>
      _.orderBy(state.menuCategories, ["order"], ["asc"]),
    menuCategoriesCategories: (state) =>
      _.orderBy(state.menuCategoriesCategories, ["order"], ["asc"]),
    menuItems: (state) => _.orderBy(state.menuItems, ["order"], "asc"),
    groupedMenuSubItems: (state) =>
      _.chain(state.menuSubItems).groupBy("course").value(),
    visitorName: (state) => state.visitorContactDetails.name,
    visitorEmail: (state) => state.visitorContactDetails.email,
    visitorPhone: (state) => state.visitorContactDetails.phone,
    marketingConsent: (state) => state.visitorContactDetails.marketingConsent,
    orderingEnabled: (state) => state.isOrderingEnabled,
    orderData: (state) => state.orderData,
    orderStatus: (state) => state.orderStatus,
    appUrl: (state) => state.appUrl,
    sessionId: () => {
      if (sessionStorage.getItem("sessionId") === null) {
        sessionStorage.setItem(
          "sessionId",
          [...Array(30)].map(() => Math.random().toString(36)[2]).join("")
        );
      }
      return sessionStorage.getItem("sessionId");
    },
    selectedMenuCategory: (state) => state.selectedMenuCategory,
    parentSelectedMenuCategory: (state) => state.parentSelectedMenuCategory,
    discountCodeInfo: (state) => state.discountCodeInfo,
    orderingSecurityCodeHash: (state) => state.orderingSecurityCodeHash,
    isListDisplayed: (state) => state.isListDisplayed,
    processBarCurrentItem: (state) => state.processBarCurrentItem,
    currentBottomIcon: (state) => state.currentBottomIcon,
    isCartViewShown: (state) => state.isCartViewShown,
    isMobileDevice: (state) => state.isMobileDevice,
    isSubSubCategory: (state) => state.isSubSubCategory,
    totalDaysVisible: (state) => state.totalDaysVisible,
    languagesCount: (state) => state.languagesCount,
    address: (state) => state.address,
    city: (state) => state.city,
    country: (state) => state.country,
    zip: (state) => state.zip,
    latAddressClient: (state) => state.latAddressClient,
    longAddressClient: (state) => state.longAddressClient,
    calculatedDistanceHomeDelivery: (state) =>
      state.calculatedDistanceHomeDelivery,
  },
  modules: {
    Cart,
  },
});
